import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports : [ReactiveFormsModule],
})
export class PasswordInputComponent extends BaseInputDirective implements OnInit {

  


  ngOnInit() {
    super.ngOnInit();
  }
}
